/**
 * color-mix() utility for token + opacity.
 * Replaces broken hex+alpha suffix pattern on CSS var strings.
 * Usage: mix(accent.forced, 25) → "color-mix(in srgb, var(--cg-accent-forced) 25%, transparent)"
 */
export const mix = (color: string, pct: number) =>
  `color-mix(in srgb, ${color} ${pct}%, transparent)`;
